export const changeStatusMenuAction = (state) => {
  return {
    open: !state.open
  }
}